export class Discount {
    id = '';
    type = '';
    private _amountOff = 0;
    private _amount = 0;
    private _percentOff = 0;
    private _percent = 0;



    get amountOff() {
        return this._amountOff || this._amount;
    }

    set amountOff(value) {
        this._amountOff = value / 100;
    }

    get amount(): number {
        return this._amount || this._amountOff;
    }

    set amount(value: number) {
        this._amount = value;
    }

    get percentOff(): number {
        return this._percentOff || this._percent;
    }

    set percentOff(value: number) {
        this._percentOff = value;
    }

    get percent(): number {
        return this._percent || this._percentOff;
    }

    set percent(value: number) {
        this._percent = value;
    }
}

